import { API } from "apps/cynaps/src/providers/ApiProvider";

export const importFiles = async ({
  files,
  body,
  project,
  onUploadStart,
  onUploadFinish,
  onFinish,
  onError,
  dontCommitToProject,
  treatZipAsFile,
}: {
  files: { name: string }[];
  body: Record<string, any> | FormData;
  project: APIProject;
  onUploadStart?: (files: { name: string }[]) => void;
  onUploadFinish?: (files: { name: string }[]) => void;
  onFinish?: (response: any) => void;
  onError?: (response: any) => void;
  dontCommitToProject?: boolean;
  treatZipAsFile?: boolean;
}) => {
  onUploadStart?.(files);

  const query: Record<string, string> = {};
  if (dontCommitToProject) query.commit_to_project = "false";
  if (treatZipAsFile) query.treat_zip_as_file = "true";

  // IMPORTANT: Don't set Content-Type for FormData!
  // The browser automatically sets it with the correct boundary parameter
  // (e.g., "multipart/form-data; boundary=----WebKitFormBoundary...")
  // Setting it manually breaks multipart parsing on the server
  const headers: Record<string, string> = {};
  if (!(body instanceof FormData)) {
    headers["Content-Type"] = "application/x-www-form-urlencoded";
  }

  // Debug: Log FormData contents
  if (body instanceof FormData) {
    console.log("Uploading FormData with entries:");
    for (const [key, value] of body.entries()) {
      if (value instanceof File) {
        console.log(`  ${key}: File(${value.name}, ${value.size} bytes, ${value.type})`);
      } else {
        console.log(`  ${key}: ${value}`);
      }
    }
  }

  const res = await API.invoke("importFiles", { pk: project.id, ...query }, { headers, body });

  if (res && !res.error) {
    await onFinish?.(res);
  } else {
    onError?.(res?.response);
  }

  onUploadFinish?.(files);
};
